<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Status do Projeto</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="Name">
                    <span class="required">*</span> Nome:
                  </label>
                  <input
                    autocomplete="new-password"
                    type="text"
                    id="Name"
                    class="form-control"
                    v-model="status_project.name"
                    placeholder=""
                  />
                </div>
              </div>
              <hr />
              <span class="required_fields">
                <span class="required">*</span>
                <strong>Campos obrigatórios</strong>
              </span>
              <div class="block text-right mb-1">
                <router-link to="/status_projects" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <a class="btn btn-add ml-1" @click="save">
                  Salvar
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import axios from "axios";

export default {
  name: "imageUpload",
  data() {
    return {
      status_project: {
        name: "",
      },
    };
  },
  methods: {
    save() {
      const self = this;
      let api = self.$store.state.api + "status_projects";

      if (self.status_project.id) {
        api += "/" + self.status_project.id;
      }

      axios
        .post(api, self.status_project)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          self.$router.push("/status_projects");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getStatusProject(id) {
      const self = this;
      const api = self.$store.state.api + "status_projects/" + id;

      axios
        .get(api)
        .then((response) => {
          self.status_project = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.getStatusProject(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
